import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CratLoader: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 375 421"
    sx={{
      width: '375px',
      height: '421px',
      fill: 'none',
      ...sx,
    }}
    {...props}
  >
    <svg
      id="Group1000003050"
      width="375"
      height="421"
      viewBox="0 0 375 421"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ maxWidth: '100%', maxHeight: '100%' }}
    >
      <mask
        id="mask0_332_3582"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="375"
        height="421"
      >
        <path
          d="M363.026 92.722L216.039 7.70183C207.258 2.60062 197.379 0 187.5 0C177.621 0 167.742 2.60062 158.861 7.70183L10.9766 93.3222C4.19106 97.2231 0 104.525 0 112.327V283.567C0 304.072 10.8768 322.977 28.6389 333.279L174.029 417.399C182.411 422.2 192.689 422.2 200.971 417.399L346.361 333.279C364.023 323.077 375 304.072 375 283.567V113.527C375 104.925 370.41 97.023 363.026 92.722ZM114.955 319.176L187.4 361.086L349.754 267.163V283.567C349.754 295.07 343.667 305.573 333.788 311.374L199.973 388.792C192.29 393.293 182.81 393.293 175.027 388.792L83.2225 335.68V152.136L161.5 105.5L128.027 89.8213L55.5814 131.731V319.676L41.2121 311.374C31.3332 305.673 25.2461 295.07 25.2461 283.567V127.33C25.2461 119.228 29.537 111.727 36.5221 107.726L137.806 53L291.877 147.735L292.077 231.455L319.518 215.551V135.032L157.165 37.909L171.434 29.607C176.324 26.8064 181.812 25.306 187.4 25.306C192.988 25.306 198.576 26.8064 203.366 29.607L340.274 108.826C346.062 112.227 349.754 117.798 349.754 124.5V239.557L186.602 333.279L137.806 302.072L155.369 282.967C158.262 284.668 161.256 286.168 164.449 287.568C174.129 291.669 184.606 293.77 196.082 293.77C207.457 293.77 217.636 291.869 226.716 287.968C235.797 284.067 243.381 279.066 249.667 272.665C255.954 266.363 260.444 259.362 263.139 251.76L237.094 239.557C234.101 247.559 229.011 254.16 221.927 259.362C214.842 264.563 206.16 267.163 196.082 267.163C188.498 267.163 181.513 265.763 175.226 262.962L187.799 250.059C198.077 239.557 197.978 222.653 187.6 212.25L186.602 211.25L154.271 244.358C153.473 243.058 152.774 241.757 152.076 240.457C147.885 232.155 145.789 222.353 145.789 211.25C145.789 200.148 147.885 190.445 152.076 182.143C156.267 173.841 162.154 167.34 169.838 162.639C177.421 157.938 186.203 155.537 196.181 155.537C206.26 155.537 214.941 158.138 222.026 163.339C229.111 168.54 234.2 175.242 237.194 183.344L263.238 170.941C260.544 163.339 256.054 156.437 249.767 150.036C243.481 143.734 235.897 138.633 226.816 134.732C217.736 130.831 207.557 128.931 196.181 128.931C184.606 128.931 174.129 130.931 164.449 135.032C154.87 139.133 146.488 144.834 139.303 152.136C132.118 159.438 126.53 168.14 122.539 178.242C118.547 188.345 116.551 199.247 116.551 211.05C116.551 222.853 118.547 233.756 122.638 243.758C125.732 251.26 129.623 258.061 134.413 264.163L96.7935 302.072C94.7978 304.072 95.2967 307.373 97.6916 308.773L114.955 319.176Z"
          fill="white"
          strokeDasharray="0,0,2732.900625,2147.2790625"
        >
          <animate
            attributeType="XML"
            attributeName="stroke-dasharray"
            repeatCount="indefinite"
            dur="5.555555555555555s"
            values="0,0,2732.900625,2147.2790625; 
          0,2147.2790625,2732.900625,0; 
          2732.900625,2147.2790625,0,0"
            keyTimes="0; 0.43999999999999995; 1"
          />
        </path>
      </mask>
      <g mask="url(#mask0_332_3582)">
        <path
          d="M206.5 214.061L109.493 302.099C108.998 302.548 109.075 303.348 109.647 303.695L184.945 349.279C185.256 349.467 185.644 349.472 185.959 349.292L365 247.053M365 247.053V140.004C365 123.631 356.297 108.493 342.149 100.253L209.002 22.7166C194.479 14.2588 176.498 14.3952 162.105 23.0722L34.2511 100.147C20.4423 108.471 12 123.418 12 139.542V280.458C12 296.582 20.4422 311.529 34.2511 319.853L65.4078 338.635M365 247.053V279.996C365 296.369 356.297 311.507 342.149 319.747L209.002 397.283C194.479 405.741 176.498 405.605 162.105 396.928L65.4078 338.635M65.4078 338.635V145.599C65.4078 145.246 65.5934 144.92 65.8963 144.74L152.386 93.2576M137.5 37.9048L305.017 142.199C305.31 142.381 305.488 142.702 305.488 143.048V236.394"
          stroke="#B4EB56"
          strokeWidth="22"
          strokeDasharray="0,0,1227.07375,964.1293749999999"
        >
          <animate
            attributeType="XML"
            attributeName="stroke-dasharray"
            repeatCount="indefinite"
            dur="5.555555555555555s"
            values="0,0,1227.07375,964.1293749999999; 
          0,964.1293749999999,1227.07375,0; 
          1227.07375,964.1293749999999,0,0"
            keyTimes="0; 0.43999999999999995; 1"
          />
        </path>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M195.113 155.015C164.899 155.015 139.48 180.926 139.48 214.061C139.48 247.195 164.899 273.106 195.113 273.106C215.578 273.106 233.723 261.332 243.427 243.351L262.788 253.8C249.591 278.252 224.371 295.106 195.113 295.106C151.726 295.106 117.48 258.297 117.48 214.061C117.48 169.825 151.726 133.015 195.113 133.015C224.371 133.015 249.591 149.869 262.788 174.321L243.427 184.77C233.723 166.789 215.578 155.015 195.113 155.015Z"
        fill="#B4EB56"
        strokeDasharray="0,0,425.17774414062507,334.06822753906243"
      >
        <animate
          attributeType="XML"
          attributeName="stroke-dasharray"
          repeatCount="indefinite"
          dur="5.555555555555555s"
          values="0,0,425.17774414062507,334.06822753906243; 
          0,334.06822753906243,425.17774414062507,0; 
          425.17774414062507,334.06822753906243,0,0"
          keyTimes="0; 0.43999999999999995; 1"
        />
      </path>
    </svg>
  </SvgIcon>
);
